class GosterimPicker extends HTMLElement {
    constructor() {
      super();
      this.radios = this.querySelectorAll('[data-gosterim-radio]');
      this.displaySpan = this.querySelector('[data-gosterim-selected-value]');
    }
  
    connectedCallback() {
      this.radios.forEach((radio) => {
        radio.addEventListener('click', this.handleSelect.bind(this));
        radio.addEventListener('change', this.handleSelect.bind(this));
      });
    }
  
    handleSelect(event) {
      const radio = event.target;
      radio.checked = true;
      if (this.displaySpan) {
        this.displaySpan.textContent = radio.value;
      }
  
      this.radios.forEach((r) => {
        if (r !== radio) r.checked = false;
      });
  
      this.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  
  if (!customElements.get('gosterim-picker')) {
    customElements.define('gosterim-picker', GosterimPicker);
  }